module.exports = __webpack_public_path__ + "img/ic24Camera.2a522e87.svg";